export const campaigns = [
  {
    id: '1',
    title: 'Árbol Rocío',
    description: 'Regalo de árbol para Rocío',
    spent: 35,
    budget: 65,
    date: '2025-01-01',
    active: true,
    ideas: [
      {
        id: '1',
        title: 'Traje medieval',
        description: 'Ha comentado que quiere un traje medieval',
        upvotes: 0,
        downvotes: 0,
        comments: [
          {
            id: '1',
            author: 'John Doe',
            authorId: 1,
            date: '2021-01-01',
            content: 'This is a comment',
          },
          {
            id: '2',
            author: 'Jane Doe',
            authorId: 2,
            date: '2021-01-01',
            content: 'This is another comment',
          },
        ],
        options: [
          {
            id: '1',
            image_url:
              'https://images1.vinted.net/t/05_01563_TjCQQcThDK18EChhHY728crJ/f800/1761823076.webp?s=553ce5da725efc66c26c302dd4c00ca55c096ce5',
            title: 'Option 1',
            description: 'Caftán verde oscuro',
            price: 115.5,
            votes: 0,
          },
          {
            id: '2',
            title: 'Option 2',
            url: 'https://www.vinted.es/items/7396260257-caftan',
            image_url:
              'https://images1.vinted.net/t/01_00655_YR5pTKAG8QtdcCXfhpQsvFnR/f800/1761321969.webp?s=cb020517aaaaf5106f32749e664ed9564ed9511b',
            description: 'Caftán Verde clarito',
            price: 57.75,
            votes: 0,
          },
        ],
      },
      {
        id: '2',
        title: 'Tocadiscos',
        description: 'This is idea 2',
        author: 'Jane Doe',
        authorId: 2,
        date: '2021-01-01',
        upvotes: 0,
        downvotes: 0,
        comments: [
          {
            id: '1',
            author: 'John Doe',
            authorId: 1,
            date: '2021-01-01',
            content: 'This is a comment',
          },
          {
            id: '2',
            author: 'Jane Doe',
            authorId: 2,
            date: '2021-01-01',
            content: 'This is another comment',
          },
        ],
        options: [
          {
            id: '1',
            title: 'Option 1',
            description: 'This is option 1',
            url: 'https://www.amazon.es/dp/B08H87HRRD?tag=compramejores-21&linkCode=ogi&th=1',
            image_url: 'https://m.media-amazon.com/images/I/71M3kcYuW2L._AC_SX679_.jpg',
            votes: 0,
          },
          {
            id: '2',
            title: 'Option 2',
            description: 'This is option 2',
            url: 'https://www.amazon.es/dp/B0FJWPKLT2?tag=compramejores-21&linkCode=ogi&th=1',
            image_url: 'https://m.media-amazon.com/images/I/61G3ghdJP9L._AC_SL1500_.jpg',
            votes: 0,
          },
        ],
      },
    ],
  },
  {
    id: '2',
    title: 'RRMM Alex 2026',
    description: 'Ideas para alexin',
    date: '2025-01-01',
    budget: 250,
    spent: 0,
    active: true,
    ideas: [
      {
        id: '1',
        title: 'Cohete',
        status: 'completed',
        description: 'Comoe el de su amigo. Que se puedan meter dentro',
        upvotes: 0,
        downvotes: 0,
        comments: [
          {
            id: '1',
            author: 'John Doe',
            authorId: 1,
            date: '2021-01-01',
            content: 'This is a comment',
          },
          {
            id: '2',
            author: 'Jane Doe',
            authorId: 2,
            date: '2021-01-01',
            content: 'This is another comment',
          },
        ],
        options: [
          {
            id: '1',
            url: 'https://es.wallapop.com/item/cohete-playmobil-con-accesorios-1206288379',
            image_url:
              'https://cdn.wallapop.com/images/10420/jy/6y/__/c10420p1206288379/i6137347163.jpg?pictureSize=W640',
            title: 'Con accesorios',
            description: 'Tiene el que mas accesorios',
            addedBy: 'rocio',
            price: 29,
            currency: 'EUR',
            votes: 0,
            comments: [{ author: 'alex', text: 'Me gusta', date: '2024-01-01', votes: 0 }],
          },
          {
            id: '2',
            title: 'Option 2',
            url: 'https://es.wallapop.com/item/playmobil-city-action-cohete-espacial-1209135925',
            image_url:
              'https://cdn.wallapop.com/images/10420/jz/vz/__/c10420p1209135925/i6155828184.jpg?pictureSize=W640',
            description: 'Playmobil City Action Cohete Espacial',
            price: 50,
            addedBy: 'rocio',
            votes: 0,
          },
        ],
      },
    ],
  },
  {
    id: '3',
    title: 'Campaña 3',
    description: 'Descripción de la campaña 3',
    date: '2025-01-01',
    active: true,
  },
]

export const friends = (campaigns: { owners: string[] }[], username: string) => {
  if (!campaigns) return []

  const list = [
    { username: 'palo', name: 'Palo' },
    { username: 'juan', name: 'Juan' },
    { username: 'kaixo', name: 'Alex' },
    { username: 'rocio', name: 'Rocío' },
    { username: 'berni', name: 'Berni' },
    { username: 'esther', name: 'Esther' },
    { username: 'fati', name: 'Fati' },
    { username: 'ignacio', name: 'Ignacio' },
  ]

  for (let i = 0; i < campaigns.length; i++) {
    const campaign = campaigns[i]
    //add current owners if missing in list
    if (campaign && campaign.owners) {
      campaign.owners.forEach((owner: string) => {
        if (!list.map((x) => x.username).includes(owner)) {
          list.push({ username: owner, name: owner })
        }
      })
    }
    //put current user first of the list:
    if (username) {
      const me_index = list.findIndex((x) => x.username == username)
      const me = list[me_index]
      list.splice(me_index, 1)
      list.unshift(me)
    }
  }

  return list
}

export function nickname(username: string) {
  const f = friends([], '').find((f) => f.username === username)
  return f ? f.name : username || '???'
}

export function groups(username: string) {
  console.warn('[fyi] groups list is the same for all for now', username)
  return [
    { value: 'arbol-2025', text: 'Árbol 2025-26' },
    { value: 'arbol-2026', text: 'Árbol 2026-27' },
    { value: 'rrmm-2026', text: 'RRMM 2026' },
    { value: 'dlm-2026', text: 'DLM 2026' },
    { value: 'rrmm-2027', text: 'RRMM 2027' },
    { value: 'other', text: 'Otros' },
  ]
}
